import React from 'react';
import { ShieldCheck, Zap, Globe, Users, Award, Smartphone } from 'lucide-react';

const About: React.FC = () => {
  const stats = [
    { label: 'Cities Covered', value: '20+', icon: Globe },
    { label: 'Happy Customers', value: '50k+', icon: Users },
    { label: 'Devices Recycled', value: '100k+', icon: Smartphone },
  ];

  const values = [
    {
      title: "Instant Payout",
      desc: "No more waiting. Get your money credited via UPI, Bank, or Cash right at your doorstep.",
      icon: Zap,
      color: "text-amber-500",
      bg: "bg-amber-50"
    },
    {
      title: "Safe & Secure",
      desc: "Full data wipe guarantee and background-verified executives for every pickup.",
      icon: ShieldCheck,
      color: "text-emerald-500",
      bg: "bg-emerald-50"
    },
    {
      title: "Best Value",
      desc: "Our AI-driven pricing engine ensures you get the highest market price for your device.",
      icon: Award,
      color: "text-indigo-500",
      bg: "bg-indigo-50"
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] pb-20">
      
      {/* --- HERO SECTION --- */}
      <div className="bg-white border-b border-slate-100 py-20 px-6 text-center">
        <div className="max-w-[800px] mx-auto">
          <span className="text-[10px] font-black uppercase tracking-[3px] text-[#363C90] bg-indigo-50 px-4 py-2 rounded-full">
            Our Mission
          </span>
          <h1 className="text-4xl md:text-6xl font-black text-slate-900 mt-8 mb-6 tracking-tight">
            The Smartest Way to <span className="text-[#363C90]">Sell & Upgrade.</span>
          </h1>
          <p className="text-slate-500 text-sm md:text-lg font-bold leading-relaxed max-w-[600px] mx-auto">
            CellZoy is redefining the re-commerce experience in India. We make selling your old gadgets as easy as ordering a coffee.
          </p>
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto px-6 -mt-10">
        
        {/* --- STATS GRID --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-20">
          {stats.map((stat, i) => (
            <div key={i} className="bg-white p-8 rounded-[32px] border border-slate-100 shadow-sm flex items-center gap-6 group hover:border-[#363C90]/20 transition-all">
              <div className="p-4 bg-slate-50 rounded-2xl text-[#363C90] group-hover:bg-[#363C90] group-hover:text-white transition-colors">
                <stat.icon size={24} />
              </div>
              <div>
                <h3 className="text-2xl font-black text-slate-900">{stat.value}</h3>
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* --- CORE VALUES --- */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-20">
          <div className="lg:col-span-5">
            <h2 className="text-3xl font-black text-slate-900 mb-6 tracking-tight">Why Choose CellZoy?</h2>
            <p className="text-slate-500 font-bold text-sm leading-relaxed mb-8">
              We started with a simple idea: selling an old phone shouldn't be a hassle. 
              No more bargaining with local shops or dealing with sketchy online buyers.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 bg-white border border-slate-100 rounded-2xl shadow-sm">
                <div className="w-2 h-2 rounded-full bg-[#363C90]" />
                <span className="text-xs font-black text-slate-700 uppercase tracking-tight">AI-Powered Valuation</span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white border border-slate-100 rounded-2xl shadow-sm">
                <div className="w-2 h-2 rounded-full bg-emerald-400" />
                <span className="text-xs font-black text-slate-700 uppercase tracking-tight">Eco-Friendly Recycling</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4">
            {values.map((v, i) => (
              <div key={i} className={`p-8 rounded-[32px] bg-white border border-slate-100 shadow-sm hover:translate-y-[-5px] transition-all ${i === 2 ? 'md:col-span-2' : ''}`}>
                <div className={`p-3 rounded-xl inline-flex mb-6 ${v.bg} ${v.color}`}>
                  <v.icon size={20} />
                </div>
                <h4 className="text-sm font-black text-slate-900 uppercase tracking-tight mb-2">{v.title}</h4>
                <p className="text-[11px] font-bold text-slate-400 leading-relaxed uppercase">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        

      </div>
    </div>
  );
};

export default About;